import { useThemeMode } from "../../context/ThemeContext";
import { Toaster } from "react-hot-toast";

const ToasterComp = () => {
  const { mode } = useThemeMode();

  return (
    <Toaster
      position="top-center"
      toastOptions={{
        duration: 4000,
        style: {
          background: mode === "dark" ? "#1e293b" : "#ffffff",
          color: mode === "dark" ? "#f1f5f9" : "#111827",
          border: mode === "dark" ? "1px solid #334155" : "1px solid #e5e7eb",
          boxShadow:
            mode === "dark"
              ? "0 10px 15px -3px rgba(0, 0, 0, 0.5)"
              : "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
        },
        success: {
          iconTheme: {
            primary: "#10b981",
            secondary: mode === "dark" ? "#1e293b" : "#ffffff",
          },
        },
        error: {
          iconTheme: {
            primary: "#ef4444",
            secondary: mode === "dark" ? "#1e293b" : "#ffffff",
          },
        },
      }}
    />
  );
};

export default ToasterComp;
